(function () {
  const selectors = {
    card: '.product-card-wrapper, .card-wrapper, .grid__item',
    productLink: 'a[href*="/products/"]',
    stock: '.domain-card-stock',
    button: 'button[name="add"]',
    variantInput: 'input.product-variant-id',
    soldOutMessage: '.sold-out-message',
    badge: '.card__badge .badge'
  };

  const fixedCards = new WeakSet();
  const productCache = new Map();

  function productJsonUrl(href) {
    try {
      const url = new URL(href, window.location.origin);
      const parts = url.pathname.split('/products/');
      if (!parts[1]) return '';
      const handle = parts[1].split('/')[0].split('?')[0];
      return `${window.location.origin}/products/${handle}.js`;
    } catch (error) {
      return '';
    }
  }

  function replaceExactText(root, from, to) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];

    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.nodeValue.trim().toLowerCase() === from) {
        nodes.push(node);
      }
    }

    nodes.forEach((node) => {
      node.nodeValue = node.nodeValue.replace(/sold out|out of stock/i, to);
    });
  }

  function inStockFromMarkup(card) {
    return Array.from(card.querySelectorAll(selectors.stock)).some((stock) => {
      const text = stock.textContent.trim().toLowerCase();
      return stock.classList.contains('domain-card-stock--in') || /\d+\s+in stock|available to order|in stock/.test(text);
    });
  }

  function setAddToCart(card, product) {
    const availableVariant = product && product.variants
      ? product.variants.find((variant) => variant.available) || product.variants[0]
      : null;
    const buttons = card.querySelectorAll(selectors.button);
    const inputs = card.querySelectorAll(selectors.variantInput);
    const stocks = card.querySelectorAll(selectors.stock);
    const soldOutMessages = card.querySelectorAll(selectors.soldOutMessage);
    const badges = card.querySelectorAll(selectors.badge);

    card.classList.add('domain-stock-fixed');

    inputs.forEach((input) => {
      input.disabled = false;
      input.removeAttribute('disabled');
      if (availableVariant && availableVariant.id) {
        input.value = availableVariant.id;
      }
    });

    buttons.forEach((button) => {
      button.disabled = false;
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
      button.classList.remove('disabled');
      const label = button.querySelector('span:not(.sold-out-message):not(.icon-wrap)') || button;
      if (/sold out/i.test(label.textContent)) {
        label.textContent = 'Add to cart';
      }
    });

    soldOutMessages.forEach((message) => message.classList.add('hidden'));

    stocks.forEach((stock) => {
      const quantity = availableVariant && Number.isFinite(availableVariant.inventory_quantity)
        ? availableVariant.inventory_quantity
        : null;
      const label = quantity && quantity > 0 ? `${quantity} in stock` : 'In stock';
      stock.textContent = 'In stock';
      if (quantity && quantity > 0) {
        stock.textContent = label;
      }
      stock.classList.remove('domain-card-stock--out');
      stock.classList.add('domain-card-stock--in');
    });

    badges.forEach((badge) => {
      if (/sold out/i.test(badge.textContent)) {
        badge.remove();
      }
    });

    replaceExactText(card, 'sold out', 'Add to cart');
    replaceExactText(card, 'out of stock', 'In stock');
  }

  async function fixCard(card) {
    if (fixedCards.has(card)) return;

    if (inStockFromMarkup(card)) {
      setAddToCart(card);
      fixedCards.add(card);
      return;
    }

    const link = card.querySelector(selectors.productLink);
    if (!link) return;

    const url = productJsonUrl(link.href);
    if (!url) return;

    try {
      let product = productCache.get(url);

      if (!product) {
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return;
        product = await response.json();
        productCache.set(url, product);
      }

      if (product && product.available) {
        setAddToCart(card, product);
        fixedCards.add(card);
      }
    } catch (error) {
      // Keep the original Shopify state if the availability endpoint cannot be read.
    }
  }

  function run() {
    document.querySelectorAll(selectors.card).forEach(fixCard);
  }

  function watch() {
    const observer = new MutationObserver(run);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      run();
      watch();
    }, { once: true });
  } else {
    run();
    watch();
  }

  window.addEventListener('pageshow', run);
  document.addEventListener('shopify:section:load', run);
  setTimeout(run, 1000);
  setTimeout(run, 3000);
  setTimeout(run, 6000);
})();
